import RequestV2 from "../helpers/request-v2"
import Endpoints from "../config/endpoints"
import {PaymentMethodsEnum} from "../enums/PaymentMethodsEnum"
import moment from "../helpers/moment";
import Request from "../helpers/request";
import {PaymentPartnersEnum} from "../enums/PaymentPartnersEnum";
import {AppConfig} from "../config/config";


export default class SaleRequests {

    static validateVoucher(voucher, releaseCode) {

        return RequestV2
            .getInstance()
            .createGetRequest(Endpoints.sale.validateVoucher, {
                voucher,
                prlCode: releaseCode
            })
    }


    static doSale(
        responsibleCode,
        buyerCode,
        releaseCode,
        guests,
        saleValue,
        unitValue,
        paymentMethod,
        installmentNumber,
        voucherName,
        paymentPartnerCode,
        shouldGenerateAllBankBillets = true,
    ) {

        const dto = {
            personCode: responsibleCode,
            personPayerCode: buyerCode,
            installmentNumber  ,
            fullValue: saleValue,
            paymentMethodCode: paymentMethod,
            shouldGenerateBankBillet: paymentMethod === PaymentMethodsEnum.BANK_BILLET.code,
            expirationDate: moment().add(2, "days"),
            voucher: voucherName,
            shouldGenerateAllBankBillets,
            itens: [
                {
                    productReleaseCode: releaseCode,
                    quantity: guests.length,
                    unitValue: saleValue,
                    guestCodes: guests.map((guest) => guest.code)
                }
            ]
        }

        // Inclui parceiro do cartao (se necessario)
        if (paymentMethod === PaymentMethodsEnum.CREDIT_CARD.code && !!paymentPartnerCode)
            dto.paymentPartnerCode = parseInt(paymentPartnerCode)


        return RequestV2
            .getInstance()
            .createPostRequest(Endpoints.sale.sell, dto)
    }


    /**
     *  Captura (nerit-mercado) & retorna codigo do parceiro de pagamento via credito.
     *  @see PaymentPartnersEnum
     */
    static async getCredCardPaymentPartner() {

        const reqResult = await Request
            .getInstance()
            .createGetRequest(Endpoints.admin.getSystemParameters + "/get/PARAM_PAYMENT_PARTNER_CODE", {}, {}, true)

        return reqResult.parameterValue || null
    }


    /** Captura & retorna dados de uma compra */
    static async getSaleData(ivaCode) {

        const url = Endpoints.invoiceAccount.get + '/' + ivaCode

        return await RequestV2
            .getInstance()
            .createGetRequest(url, {}, {}, false)
    }


    /** Chama endpoint para conclusao de uma venda via credito com parceiro de venda PayPal. */
    static async finishPayPalSale(ivaCode, paymentID, payerID) {

        const url = AppConfig.nm_api.baseUrlOld + "invoiceaccount/executePayPalPayment"

        const params = {
            ivaCode,
            paymentID,
            payerID
        }

        return await RequestV2
            .getInstance()
            .createGetRequest(url, params, {})
    }
}



// WEBPACK FOOTER //
// ./src/requests/sale-requests.js